import { ASTUR_X_TOKEN } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

export interface DisconnectConsentResult {
  disconnected: boolean;
  tokens_deleted: number;
}

type DisconnectConsentApiEnvelope = {
  result?: DisconnectConsentResult;
};

export async function disconnectConsent(
  scope: RequestScope,
  args: { subscriptionId: number },
  options: WriteRequestOptions
): Promise<ChannelApiResponse<DisconnectConsentResult>> {
  if (!Number.isFinite(args.subscriptionId) || args.subscriptionId < 1) {
    return {
      isError: true,
      failureKind: 'failed',
      status: 0,
      errors: { error: 'Valid subscription ID is required' },
    };
  }
  try {
    const res = await scopedChannelApi(scope).post<DisconnectConsentApiEnvelope>(
      'astur/subscription/consent/disconnect',
      { subscription_id: args.subscriptionId },
      {
        ...options,
        headers: {
          'x-astur-token': ASTUR_X_TOKEN,
          'X-Astur-Subscription-Id': String(args.subscriptionId),
        },
      }
    );

    const data = res.data?.result;

    return {
      data: {
        disconnected: data?.disconnected ?? false,
        tokens_deleted: data?.tokens_deleted ?? 0,
      },
      status: res.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
